/**
 * Multi Column Block — scroll to next section
 */
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-scroll-next-section]').forEach((button) => {
        button.addEventListener('click', () => {
            const section = button.closest('section');

            if (!section) {
                return;
            }

            const nextSection = section.nextElementSibling;

            if (!nextSection || nextSection.tagName !== 'SECTION') {
                return;
            }

            const header = document.querySelector('header');
            const headerHeight = header ? header.offsetHeight : 0;
            const targetPosition = nextSection.offsetTop - headerHeight - 20;

            if (window.lenis) {
                window.lenis.scrollTo(targetPosition, { duration: 1.5 });
            } else if (typeof gsap !== 'undefined') {
                gsap.to(window, {
                    duration: 1.5,
                    scrollTo: { y: targetPosition, autoKill: false },
                    ease: 'power2.inOut',
                });
            } else {
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth',
                });
            }
        });
    });
});
